/* EzLift delivery estimate. Vanilla JS, no deps. Data: assets/ezlift-delivery-data.json */
(function () {
  var TZ = 'America/New_York', KEY = 'ezlift_zip', dataP = null;
  function getData(url) { return dataP || (dataP = fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); })); }
  function ymd(y, m, d) { return new Date(Date.UTC(y, m, d)); }
  function nth(y, m, wd, n) { var d = ymd(y, m, 1); var off = (wd - d.getUTCDay() + 7) % 7; return ymd(y, m, 1 + off + 7 * (n - 1)); }
  function last(y, m, wd) { var d = ymd(y, m + 1, 0); return ymd(y, m, d.getUTCDate() - ((d.getUTCDay() - wd + 7) % 7)); }
  function obs(d) { var w = d.getUTCDay(); return w === 6 ? add(d, -1) : w === 0 ? add(d, 1) : d; }
  function add(d, n) { return new Date(d.getTime() + n * 864e5); }
  var hcache = {};
  function holidays(y) {
    if (hcache[y]) return hcache[y];
    var l = [obs(ymd(y, 0, 1)), nth(y, 0, 1, 3), nth(y, 1, 1, 3), last(y, 4, 1), obs(ymd(y, 5, 19)), obs(ymd(y, 6, 4)),
      nth(y, 8, 1, 1), nth(y, 9, 1, 2), obs(ymd(y, 10, 11)), nth(y, 10, 4, 4), obs(ymd(y, 11, 25)), obs(ymd(y + 1, 0, 1))];
    var s = {}; l.forEach(function (d) { s[d.toISOString().slice(0, 10)] = 1; }); return (hcache[y] = s);
  }
  function isBiz(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && !holidays(d.getUTCFullYear())[d.toISOString().slice(0, 10)]; }
  function addBiz(d, n) { while (n > 0) { d = add(d, 1); if (isBiz(d)) n--; } return d; }
  function nowET() {
    var p = {}; new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = +x.value; });
    return { date: ymd(p.year, p.month - 1, p.day), hour: p.hour };
  }
  /* Day 0 = the business day the order is processed. Range counts business days after day 0. */
  function startDay(cutoff, from) {
    if (from) { var f = from; if (!isBiz(f)) { while (!isBiz(f)) f = add(f, 1); } return f; }
    var n = nowET(), d = n.date;
    if (!isBiz(d) || n.hour >= cutoff) { d = add(d, 1); while (!isBiz(d)) d = add(d, 1); }
    return d;
  }
  var fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' });
  /* Priority line: shown only after a dated estimate, never on pre-orders (future ship date). Rate name matches checkout. */
  function fast(root, on) {
    var el = root.querySelector('[data-ezde-fast]'); if (!el) return;
    if (!on) { el.textContent = ''; return; }
    el.innerHTML = 'Need it fast? Add <strong>Priority Shipping</strong> at checkout.';
  }
  function render(root, data) {
    var input = root.querySelector('input'), out = root.querySelector('[data-ezde-out]');
    var zip = (input.value || '').trim();
    fast(root, false);
    if (!/^\d{5}$/.test(zip)) { out.textContent = 'Please enter a 5-digit ZIP code.'; return; }
    try { localStorage.setItem(KEY, zip); } catch (e) {}
    var grp = data.groups[root.getAttribute('data-group')], r = grp && grp[zip.charAt(0)];
    if (!r) { out.textContent = ''; return; }
    var lo = r[0], hi = r[1] > r[0] ? r[1] : r[0] + 1;
    var sd = root.getAttribute('data-ship-date'), from = null;
    if (sd && /^\d{4}-\d{2}-\d{2}$/.test(sd)) { var a = sd.split('-'); from = ymd(+a[0], a[1] - 1, +a[2]); var t = nowET().date; if (from < t) from = null; }
    var s = startDay(data.cutoff_hour_et || 16, from);
    out.textContent = 'Estimated delivery: ' + fmt.format(addBiz(s, lo)) + ' \u2013 ' + fmt.format(addBiz(s, hi));
    fast(root, !from);
  }
  function hourLabel(h) { return (h % 12 || 12) + (h < 12 ? ' AM' : ' PM'); }
  function cutoffLine(root, data) {
    var el = root.querySelector('[data-ezde-cutoff]'); if (!el) return;
    var c = data.cutoff_hour_et || 16, n = nowET();
    if (isBiz(n.date) && n.hour < c) el.textContent = 'Order by ' + hourLabel(c) + ' ET today to ship ' + fmt.format(addBiz(n.date, 1)) + '.';
    else el.textContent = 'Order by ' + hourLabel(c) + ' ET to ship next business day.';
  }
  function init(root) {
    var form = root.querySelector('form'), input = root.querySelector('input'), url = root.getAttribute('data-src');
    getData(url).then(function (d) { cutoffLine(root, d); }).catch(function () {});
    form.addEventListener('submit', function (e) { e.preventDefault(); getData(url).then(function (d) { render(root, d); }).catch(function () {}); });
    var saved = null; try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (saved && /^\d{5}$/.test(saved)) { input.value = saved; getData(url).then(function (d) { render(root, d); }).catch(function () {}); }
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-ezde]'), function (el) { if (!el._ezde) { el._ezde = 1; init(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.EzDE = { _addBiz: addBiz, _holidays: holidays, _ymd: ymd, _isBiz: isBiz };
})();
